import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { MapPin, Upload, Check, Download } from 'lucide-react';
import { UPLOAD_CARDS } from './homeConstants';

export default function FootprintModal({ open, onOpenChange, uploads, remaining, allComplete, onUpload }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-[#242730] border-[#2E3240] text-white">
        <DialogHeader>
          <DialogTitle className="text-white text-lg font-black flex items-center gap-2">
            <MapPin className="h-5 w-5 text-[#A78BFA]" />Power up your 1st Party Data Room
          </DialogTitle>
          <DialogDescription className="text-gray-500">
            {allComplete
              ? 'All uploads complete! Your data room is fully activated.'
              : `${remaining} upload${remaining !== 1 ? 's' : ''} remaining — each one makes your Waves smarter.`}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2" data-testid="upload-cards">
          {UPLOAD_CARDS.map(card => {
            const done = uploads[card.id];
            const Icon = card.icon;
            return (
              <div key={card.id}
                   className={`rounded-xl p-4 transition-all ${done ? 'bg-green-500/5 border border-green-500/20' : 'bg-[#181A20] border border-[#2E3240] hover:border-[#00D4FF]/20'}`}
                   data-testid={`upload-card-${card.id}`}>
                <div className="flex items-start gap-4">
                  <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${done ? 'bg-green-500/15' : 'bg-[#00D4FF]/10'}`}>
                    {done ? <Check className="h-5 w-5 text-green-400" /> : <Icon className="h-5 w-5 text-[#00D4FF]" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-0.5">
                      <h4 className="text-sm font-bold text-white">{card.title}</h4>
                      {done && <span className="text-[8px] px-1.5 py-0.5 rounded-full bg-green-500/15 text-green-400 font-bold">Uploaded</span>}
                    </div>
                    <p className="text-[10px] text-gray-500 mb-1">{card.format}</p>
                    <p className="text-[10px] text-gray-400 mb-3">{card.benefit}</p>
                    {!done && (
                      <div className="flex items-center gap-3">
                        <button onClick={() => onUpload(card.id)}
                                className="px-4 py-2 rounded-lg bg-[#00D4FF]/10 border border-[#00D4FF]/20 text-[#00D4FF] text-[10px] font-bold hover:bg-[#00D4FF]/20 transition-all flex items-center gap-1.5"
                                data-testid={`upload-btn-${card.id}`}>
                          <Upload className="h-3 w-3" />Select File
                        </button>
                        <button className="text-[9px] text-gray-500 hover:text-[#00D4FF] transition-all flex items-center gap-1">
                          <Download className="h-3 w-3" />Download template
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="rounded-lg p-3 mt-1" style={{ background: '#00D4FF08', border: '1px solid #00D4FF15' }} data-testid="intelligence-note">
          <p className="text-[9px] text-gray-400 leading-relaxed">
            <span className="font-semibold text-[#00D4FF]">Platform Intelligence:</span> Every upload you provide helps train Wave's algorithm across the entire platform.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
